import {Component} from 'react'
import {Dispath} from 'react-redux'


type Props = {
    dispatch: Dispath<any>
}
type State = {}

export class AbstractConstantContractTypeViewComponent extends Component <Props, State>{
    constructor(props:Props){
        super(props)
        this.state ={
            loading: false,
            loading_text:'Loading',
            tableData:[
                {
                    name:{
                        field:'text',
                        route:false,
                        sortable:true,
                        translate:'course:unit'
                    },
                    action:{
                        field:'button',
                        route:true,
                        sortable:false,
                        translate:'activity:action',
                    }
                }
            ]
        }
    }
    compnentDidMount(){}


}

export function mapStateToProps(state:Object){
    return {
        token: state.token,
    }
}